import { Description } from "@mui/icons-material";
import { Card } from "@cofano/cck";
import { CompactCharterFragment } from "__generated__/view/charters/graphql/charter.fragments.generated";
import { DocumentEntity } from "__generated__/graphql";
import Documents, { DocumentOptionalColumns, Entity } from "components/documents/Documents";
import { getDocumentsCardTitle } from "components/documents/DocumentsUtils";

type CharterDocumentsProps = {
	charter: CompactCharterFragment;
}

const CharterDocuments = ({ charter }: CharterDocumentsProps) => {

	const charterEntity: Entity = {
		id: charter.id,
		name: charter.charterNumber,
		type: DocumentEntity.Charter,
	};

	return (
		<div>
			<Card title={getDocumentsCardTitle([ charterEntity ])} icon={<Description fontSize="small" color="primary" />} disablePadding>
				<Documents
					entities={[ charterEntity ]}
					showOptionalColumns={[ DocumentOptionalColumns.Entity ]}
				/>
			</Card>
		</div>
	);
};

export default CharterDocuments;
